import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  colspan: "1",
  style: {"width":"64px"}
}
const _hoisted_2 = {
  colspan: "100",
  style: {"padding-left":"0"}
}
const _hoisted_3 = { style: {"white-space":"nowrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!

  return (_openBlock(), _createBlock(_component_v_data_table_server, {
    modelValue: _ctx.selected,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selected) = $event)),
    "show-select": !!_ctx.showSelect,
    "item-value": _ctx.itemValue,
    headers: _ctx.headers || [],
    items: _ctx.displayedItems,
    page: _ctx.page_,
    "items-length": _ctx.totalItems_,
    "items-per-page": _ctx.rowsPerPage_,
    "footer-props": _ctx.footerProps_,
    loading: _ctx.loading,
    class: _normalizeClass(_ctx.classTable),
    "hide-default-header": _ctx.hideDefaultHeader,
    "hide-default-footer": "",
    "fixed-header": _ctx.fixedHeader,
    height: _ctx.height,
    style: _normalizeStyle(_ctx.contentStyle),
    calculateWidths: _ctx.calculateWidths,
    dense: _ctx.dense,
    "return-object": _ctx.returnObject
  }, {
    headers: _withCtx((props) => [
      _createElementVNode("tr", null, [
        (_ctx.showSelect)
          ? (_openBlock(), _createElementBlock("th", _hoisted_1, [
              _createVNode(_component_v_checkbox, {
                indeterminate: props.someSelected,
                onClick: _withModifiers(($event: any) => (props.selectAll(!props.allSelected)), ["stop","prevent"]),
                "model-value": props.allSelected,
                "hide-details": ""
              }, null, 8, ["indeterminate", "onClick", "model-value"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("th", _hoisted_2, [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "7",
                class: "pl-2"
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "header", {
                    props: props.headers,
                    isMobile: _ctx.$vuetify.display.mobile
                  })
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_col, {
                cols: "5",
                class: "d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.sortBy_,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sortBy_) = $event)),
                    items: _ctx.sortByList,
                    style: {"font-size":"0.75rem","width":"min-content"},
                    "hide-details": "",
                    "item-value": "key",
                    width: "50px",
                    label: "Trier par",
                    "return-object": "",
                    density: "compact",
                    "item-title": "text"
                  }, null, 8, ["modelValue", "items"]),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.rowsPerPage_,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rowsPerPage_) = $event)),
                    items: [5, 10, 25],
                    "hide-details": "",
                    label: "Lignes par page",
                    outlined: "",
                    style: {"font-size":"0.75rem","width":"min-content"},
                    width: "100px",
                    density: "compact"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("span", _hoisted_3, _toDisplayString((_ctx.page_ - 1) * _ctx.rowsPerPage_ + 1) + " - " + _toDisplayString((_ctx.page_ - 1) * _ctx.rowsPerPage_ + _ctx.rowsPerPage_) + " de " + _toDisplayString(_ctx.totalItems_), 1),
                  _createVNode(_component_v_btn_prev, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.page_--)),
                    disabled: _ctx.page_ === 1,
                    size: "small"
                  }, null, 8, ["disabled"]),
                  _createVNode(_component_v_btn_next, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.page_++)),
                    size: "small",
                    disabled: _ctx.nextPageDisabled
                  }, null, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1024)
        ])
      ])
    ]),
    "body.append": _withCtx(({
                page,
                itemsPerPage,
                sortBy,
                pageCount,
                toggleSort,
                setItemsPerPage,
                someSelected,
                allSelected,
                isSelected,
                select,
                selectAll,
                toggleSelect,
                isExpanded,
                toggleExpand,
                isGroupOpen,
                toggleGroup,
                items,
                internalItems,
                groupedItems,
                columns,
                headers,
            }) => [
      _renderSlot(_ctx.$slots, "body.append", {
        items: items,
        pagination: _ctx.pagination,
        groupedItems: groupedItems,
        headers: headers,
        isMobile: _ctx.$vuetify.display.mobile,
        isSelected: isSelected,
        select: select,
        isExpanded: isExpanded,
        toggleExpand: toggleExpand
      })
    ]),
    "body.prepend": _withCtx(({ items, groupedItems, headers, isSelected, select, isExpanded }) => [
      _renderSlot(_ctx.$slots, "body.prepend", {
        items: items,
        pagination: _ctx.pagination,
        groupedItems: groupedItems,
        headers: headers,
        isMobile: _ctx.$vuetify.display.mobile,
        isSelected: isSelected,
        select: select,
        isExpanded: isExpanded
      })
    ]),
    "expanded-row": _withCtx(({ item, columns }) => [
      _renderSlot(_ctx.$slots, "expanded-row", {
        isMobile: _ctx.$vuetify.display.mobile,
        item: item,
        columns: columns
      })
    ]),
    "footer.prepend": _withCtx(() => [
      _renderSlot(_ctx.$slots, "footer.prepend")
    ]),
    loading: _withCtx(() => [
      _renderSlot(_ctx.$slots, "loading")
    ]),
    "no-data": _withCtx(() => [
      _renderSlot(_ctx.$slots, "no-data")
    ]),
    top: _withCtx(({ items, groupedItems }) => [
      _renderSlot(_ctx.$slots, "top", {
        items: items,
        pagination: _ctx.pagination,
        groupedItems: groupedItems
      })
    ]),
    item: _withCtx(({
                item,
                index,
                toggleExpand,
                isExpanded,
                isSelected,
                toggleSelect,
                internalItem,
            }) => [
      _renderSlot(_ctx.$slots, "item", {
        item: item,
        index: index,
        expand: toggleExpand,
        isExpanded: isExpanded,
        isMobile: _ctx.$vuetify.display.mobile,
        isSelected: isSelected(internalItem),
        select: () => toggleSelect(internalItem),
        headers: _ctx.headers
      })
    ]),
    _: 3
  }, 8, ["modelValue", "show-select", "item-value", "headers", "items", "page", "items-length", "items-per-page", "footer-props", "loading", "class", "hide-default-header", "fixed-header", "height", "style", "calculateWidths", "dense", "return-object"]))
}